module.exports = __webpack_public_path__ + "static/media/Montserrat-BlackItalic.3f8e2efd.ttf";